import React from "react";
class UserContainer extends React.Component {
  render() {
    return (
      <div
        style={{
          textAlign: "center",
          fontSize: 16,
          marginTop: 40,
          color: "#212122"
        }}
      >
        Loading...
      </div>
    );
  }
}

export default UserContainer;
